/**
 * Products List Tabs - Swiper initialization & tab switching
 * v2 : nombre de cartes visibles sur mobile/tablette réglable via data-mobile-per-view / data-tablet-per-view
 */

class ProductsListTabs {
  constructor() {
    this.sections = document.querySelectorAll('[data-section-type="products-list-tabs"]');
    this.sections.forEach((section) => this.initSection(section));
  }

  initSection(section) {
    const tabs = section.querySelectorAll('[data-tab-index]');
    const collections = section.querySelectorAll('[data-collection-index]');
    const swipers = {};

    collections.forEach((collection) => {
      const index = collection.dataset.collectionIndex;
      const swiperEl = collection.querySelector('[data-swiper-tabs]');
      if (!swiperEl) return;

      const prevEl = collection.querySelector('[data-nav-prev]');
      const nextEl = collection.querySelector('[data-nav-next]');
      const dotsEl = collection.querySelector('[data-nav-dots]');

      const navEl = collection.querySelector('.section-products-list-tabs__navigation');
      const mobilePerView = parseFloat(swiperEl.dataset.mobilePerView || '1.2') || 1.2;
      const tabletPerView = parseFloat(swiperEl.dataset.tabletPerView || '2') || 2;

      swipers[index] = new Swiper(swiperEl, {
        slidesPerView: mobilePerView,
        spaceBetween: 12,
        speed: 600,
        breakpoints: {
          768: {
            slidesPerView: tabletPerView,
            spaceBetween: 12,
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl,
        },
        pagination: {
          el: dotsEl,
          clickable: true,
          type: 'bullets',
        },
        on: {
          init: function () {
            toggleNavVisibility(this, navEl);
          },
          resize: function () {
            toggleNavVisibility(this, navEl);
          },
        },
      });
    });

    function toggleNavVisibility(swiper, nav) {
      if (!nav) return;
      const slidesCount = swiper.slides.length;
      const perView = swiper.params.slidesPerView;
      nav.style.display = slidesCount <= perView ? 'none' : '';
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetIndex = tab.dataset.tabIndex;

        tabs.forEach((t) => {
          t.classList.remove('section-products-list-tabs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('section-products-list-tabs__tab--active');
        tab.setAttribute('aria-selected', 'true');

        collections.forEach((c) => {
          if (c.dataset.collectionIndex === targetIndex) {
            c.classList.remove('section-products-list-tabs__collection--hidden');
          } else {
            c.classList.add('section-products-list-tabs__collection--hidden');
          }
        });

        if (swipers[targetIndex]) {
          swipers[targetIndex].update();
        }
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductsListTabs();
  });
} else {
  new ProductsListTabs();
}

window.ProductsListTabs = ProductsListTabs;
